var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceFloppy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16536 2.33333V4.66667H4.66536V2.33333M3.4987 2.33333H9.33203L11.6654 4.66667V10.5C11.6654 10.8094 11.5424 11.1062 11.3237 11.325C11.1049 11.5437 10.8081 11.6667 10.4987 11.6667H3.4987C3.18928 11.6667 2.89253 11.5437 2.67374 11.325C2.45495 11.1062 2.33203 10.8094 2.33203 10.5V3.5C2.33203 3.19058 2.45495 2.89383 2.67374 2.67504C2.89253 2.45625 3.18928 2.33333 3.4987 2.33333ZM5.83203 8.16667C5.83203 8.47608 5.95495 8.77283 6.17374 8.99162C6.39253 9.21042 6.68928 9.33333 6.9987 9.33333C7.30812 9.33333 7.60486 9.21042 7.82366 8.99162C8.04245 8.77283 8.16536 8.47608 8.16536 8.16667C8.16536 7.85725 8.04245 7.5605 7.82366 7.34171C7.60486 7.12292 7.30812 7 6.9987 7C6.68928 7 6.39253 7.12292 6.17374 7.34171C5.95495 7.5605 5.83203 7.85725 5.83203 8.16667Z",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceFloppy);
export default __webpack_public_path__ + "static/media/device-floppy.151ffaf15ebd064e536e911bf10234f4.svg";
export { ForwardRef as ReactComponent };